<div class="grid-container">
  @if (loading) {
    <div class="grid-blocker">
      <mds-icon [key]="icon.LOADING" [width]="40" [height]="40"></mds-icon>
    </div>
  }
  @if (overrides) {
    <mds-grid
      class="grid-view"
      [themeClass]="'ag-theme-material'"
      [minHeight]="'100%'"
      [overrides]="overrides"
      [sizeColumnsToFit]="false"
      [storageKey]="'app.analyze'"
      (rowDoubleClicked)="onRowDoubleClicked($event)"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChange()"
      (exportFinished)="setGridState()"
      (gridStateChanged)="onGridStateChanged()"
    ></mds-grid>
  }
</div>
